import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, message, Spin } from 'antd';
import {
    BankOutlined, UserOutlined, TeamOutlined, ExperimentOutlined,
    MedicineBoxOutlined, FileTextOutlined, SolutionOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { hospitalAdminService } from '../../services';

const HospitalAdminDashboard = () => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = await hospitalAdminService.getDashboard();
                setData(res.data);
            } catch (error) {
                message.error(error.response?.data?.message || t('error'));
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const cards = [
        { title: t('branches') || 'Branches', value: data?.totalBranches, icon: <BankOutlined />, color: '#05668D' },
        { title: t('doctors') || 'Doctors', value: data?.totalDoctors, icon: <UserOutlined />, color: '#028090' },
        { title: t('secretaries') || 'Secretaries', value: data?.totalSecretaries, icon: <TeamOutlined />, color: '#00A896' },
        { title: t('labs') || 'Labs', value: data?.totalLabs, icon: <ExperimentOutlined />, color: '#02C39A' },
        { title: t('pharmacies') || 'Pharmacies', value: data?.totalPharmacies, icon: <MedicineBoxOutlined />, color: '#0a9396' },
        { title: t('patients') || 'Patients', value: data?.totalPatients, icon: <SolutionOutlined />, color: '#588157' },
        { title: t('activePrescriptions') || 'Active Prescriptions', value: data?.activePrescriptions, icon: <MedicineBoxOutlined />, color: '#bc6c25' },
        { title: t('pendingTests') || 'Pending Tests', value: data?.pendingTests, icon: <FileTextOutlined />, color: '#9b2226' }
    ];

    return (
        <div className="page-container">
            <h1 style={{ marginBottom: 16 }}><BankOutlined /> {t('dashboard') || 'Dashboard'}</h1>
            <Spin spinning={loading}>
                <Row gutter={[16, 16]}>
                    {cards.map((c) => (
                        <Col xs={24} sm={12} lg={6} key={c.title}>
                            <Card>
                                <Statistic
                                    title={c.title}
                                    value={c.value || 0}
                                    prefix={c.icon}
                                    valueStyle={{ color: c.color }}
                                />
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Spin>
        </div>
    );
};

export default HospitalAdminDashboard;
